import type { ProcessFilterValues } from '../procesLijsten';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getProcessesOverview } from '../processes.api';

const OVERVIEW_QUERY_KEY = ['processes', 'overview'] as const;

/** Server-state for the procesoverzicht-landing (TanStack Query, never Zustand). */
/**
 * Story 3.1 beschrijft de filterbalk als gedeeld over élke processen-pagina. Het overzicht had
 * hem niet (gemeten 27-08-2026), en daarmee ook geen filters om door te geven. De filters horen
 * in de cache-sleutel: zonder dat toont het overzicht de vorige selectie na een filterwissel.
 */
export function useProcessesOverview(filters: ProcessFilterValues = {}) {
  return useQuery({
    queryKey: [...OVERVIEW_QUERY_KEY, filters],
    queryFn: () => getProcessesOverview({ filters }),
    staleTime: 30 * 1000,
  });
}

/** UXR9: handmatige ververs-actie — invalideert de BFF-cache-key en herlaadt de query. */
export function useRefreshProcessesOverview() {
  const queryClient = useQueryClient();
  return async () => {
    await getProcessesOverview({ refresh: true });
    await queryClient.invalidateQueries({ queryKey: OVERVIEW_QUERY_KEY });
  };
}
